export default __webpack_public_path__ + "static/media/store_svg9.cb8fab1f.svg";